<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <Invira-user-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import InviraUserShowData from "./InviraUserShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "InviraUserShow",
        components: {CrudShow, InviraUserShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'admin.inviraUser.showing',
            }
        },
    }
</script>

